import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ProfileModule } from '@iot-platform/data-access/users';
import { DetailPopupModule, FilterEngineV2Component, PhoneNumberInputComponent, ToolbarV2Module } from '@iot-platform/iot-platform-ui';
import { InfoDisplayPipe } from '@iot-platform/pipes';
import { MasterViewEngineModule } from '@iot-platform/table-engine';
import { UserRelatedBusinessProfilesComponent } from '@iot-platform/ui/users';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { AdminRouterModule } from './admin.router.module';
import { UserFormDialogComponent } from './components/user-form-dialog/user-form-dialog.component';
import { UserLinkBusinessProfileDialogComponent } from './components/user-link-business-profile-dialog/user-link-business-profile-dialog.component';
import { UserPreferencesFormDialogComponent } from './components/user-preferences-form-dialog/user-preferences-form-dialog.component';
import { UserProfileFormComponent } from './components/user-profile-form/user-profile-form.component';
import { UserProfileInfoComponent } from './components/user-profile-info/user-profile-info.component';
import { UserProfilePreferencesComponent } from './components/user-profile-preferences/user-profile-preferences.component';
import { AdminUsersComponent } from './containers/admin-users/admin-users.component';
import { UserProfileShellComponent } from './containers/user-profile-shell/user-profile-shell.component';
import { AdminBusinessProfilesEffects } from './state/effects/admin-business-profiles.effects';
import { AdminUsersEffects } from './state/effects/admin-users.effects';
import * as fromAdmin from './state/reducers';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatToolbarModule,
    MatTooltipModule,
    TranslatePipe,
    TranslateDirective,
    AdminRouterModule,
    DetailPopupModule,
    ToolbarV2Module,
    MasterViewEngineModule,
    ProfileModule,
    StoreModule.forFeature(fromAdmin.featureKey, fromAdmin.reducers),
    EffectsModule.forFeature([AdminBusinessProfilesEffects, AdminUsersEffects]),
    UserRelatedBusinessProfilesComponent,
    PhoneNumberInputComponent,
    InfoDisplayPipe,
    FilterEngineV2Component
  ],
  declarations: [
    AdminUsersComponent,
    UserLinkBusinessProfileDialogComponent,
    UserFormDialogComponent,
    UserProfileShellComponent,
    UserPreferencesFormDialogComponent,
    UserProfileInfoComponent,
    UserProfilePreferencesComponent,
    UserProfileFormComponent
  ]
})
export class OyanUiAdminModule {}
